<script>
import BaseReportManager from '../base-report/BaseReportManager.vue'

export default class InvoiceExemptCancelledReport extends BaseReportManager {
}
</script>
